import React, { useContext, useState } from "react";
import { ViewportElement } from "@foundation/viewport-element";
import { TerminalTout } from "@bloomberg/media-ui-core";
import styles from "./quotePageLayout.module.css";
import { QuoteContext } from "~context/QuoteContext";
import { SecurityList } from "~components/dynamic";
import Share from "~components/Share";
import YourWatchlist from "~components/YourWatchlist";
import BazaarInBodyAd from "~components/ads/BazaarInBodyAd";
import { useLocale } from "~hooks/i18n/useLocale";

export default function BottomSection() {
  const quoteData = useContext(QuoteContext);
  const [enteredSecurityList, setEnteredSecurityList] = useState(false);
  const { isJapanese } = useLocale();

  if (!quoteData) {
    return null;
  }

  return (
    <div className={styles.bottomSection}>
      <div className={styles.smallDesktopDown}>
        <div className={styles.securityListWrap}>
          <ViewportElement
            onEnter={() => setEnteredSecurityList(true)}
            rootMargin={`400px`}
          >
            {enteredSecurityList && <SecurityList wrap />}
          </ViewportElement>
        </div>
        <Share className={styles.share} />
        <TerminalTout centerAligned />
        {!isJapanese && <YourWatchlist className={styles.yourWatchList} />}
      </div>
      <BazaarInBodyAd className={styles.tabletUp} />
    </div>
  );
}
